var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.condition)?_c('div',{staticClass:"modal"},[(_vm.condition)?_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container",on:{"scroll":_vm.onScroll}},[_vm._t("default")],2)])])]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }